import PropTypes from 'prop-types'
import { SIZE } from 'baseui/input'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import useIbanVerifier from '@/containers/SubscriptionFormPageNew/Components/IbanVerifier/useIbanVerifier'
import {
  StyledContainer,
  StyledResult,
  StyledTitle,
} from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/IbanVerifier/styled-components'

const IbanVerifier = ({ hidden }) => {
  const { t, iban, setIban, canVerify, verifyIban, ibanIsLoading, bic, error } = useIbanVerifier()

  if (hidden) {
    return null
  }

  return (
    <StyledContainer>
      <StyledTitle>{t('subscriptionTools:iban_verifier.module_title')}</StyledTitle>
      <SDFormControl label={t('subscriptionTools:iban_verifier.iban')} error={error}>
        <SDInput
          id='iban-verifier-input'
          placeholder={t('subscriptionTools:iban_verifier.placeholder')}
          currentValue={iban}
          outerOnchange={setIban}
          error={!!error}
          autoComplete='off'
        />
      </SDFormControl>
      <SDButton
        block
        id='iban-verifier-button'
        size={SIZE.compact}
        isLoading={ibanIsLoading}
        disabled={!canVerify}
        onClick={verifyIban}
      >
        {t('subscriptionTools:iban_verifier.search_button')}
      </SDButton>
      <StyledResult id='iban-verifier-bic'>
        {t('subscriptionTools:iban_verifier.bic_result')} {bic || '—'}
      </StyledResult>
    </StyledContainer>
  )
}

IbanVerifier.propTypes = {
  hidden: PropTypes.bool,
}

export default IbanVerifier
